import { toast } from "react-toastify";
import { IAutomaticTaskOperationResult } from "src/Interfaces/automaticMarketMaking";

export function showTaskOperationResult(result: IAutomaticTaskOperationResult) {
  if (result.data) {
    toast.success(result.errors?.length && result.succeededTaskIds
      ? `عملیات برای ${result.succeededTaskIds.length} تسک انجام شد`
      : result.msg);
  }

  if (result.errors?.length) {
    toast.error(result.errors
      .map(error => `${error.optionName}: ${error.message}`)
      .join("؛ "));
  } else if (!result.data) {
    toast.error(result.msg);
  }
}
